import { IconProps } from "./icon-props";

export const CheckCheckIcon = ({ ...props }: IconProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" { ...props }>
    <path d="M18 6L7 17L2 12" stroke="#429EFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 10L14.5 17.5L13 16" stroke="#429EFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
